import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=f1b4f89a&scoped=true&"
import script from "./Pricing.vue?vue&type=script&lang=js&"
export * from "./Pricing.vue?vue&type=script&lang=js&"
import style0 from "./Pricing.vue?vue&type=style&index=0&id=f1b4f89a&lang=scss&scoped=true&"
import style1 from "./Pricing.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b4f89a",
  null
  
)

export default component.exports